module.exports = __webpack_public_path__ + "img/Profile_Grey_Icon.d7976cd6.png";